import dialogPolyfill from 'dialog-polyfill';
import 'style-loader!dialog-polyfill/dialog-polyfill.css';
import 'style-loader!./dialog.css';
import $ from 'jquery';

export default class Dialog extends HTMLElement {

  constructor () {
    super();
    this.dialog = document.createElement('dialog');
    this.dialog.addEventListener('cancel', onCancel.bind(this));
    this.dialog.addEventListener('close', onClose.bind(this));
    this.dialog.addEventListener('click', onClick.bind(this));
    dialogPolyfill.registerDialog(this.dialog);
  }

  connectedCallback () {
    this.appendChild(this.dialog);
    this.onConnected();
  }

  disconnectedCallback () {
    this.onDisconnected();
  }

  get open () {
    return this.dialog.open;
  }

  set returnValue (value) {
    this._returnValue = value;
    this.dialog.returnValue = '';
  }

  get returnValue () {
    return this.dialog.returnValue || this._returnValue;
  }

  dispatchCancel () {
    return this.dispatchEvent(new CustomEvent('cancel', {cancelable: true}));
  }

  dispatchClose () {
    return this.dispatchEvent(new CustomEvent('close'));
  }

  cancel () {
    if (this.dispatchCancel()) {
      this.close();
    }
  }

  close (returnValue) {
    this.returnValue = returnValue;
    this.dialog.close();
  }

  show () {
    this.dialog.show();
    this.onShown();
  }

  showModal () {
    this.activeElement = document.activeElement;
    this.lockFocus();
    this.dialog.showModal();
    this.onShown();
  }

  lockFocus () {
    this.unlockFocus();

    const dialog = this.dialog;
    const tabbableSelector = ':tabbable, .tabbable';
    $(dialog).on('keydown.lock-focus', tabbableSelector, function (event) {
      if (event.key === 'Tab') {
        const $tabbables = $(tabbableSelector, dialog);
        const $firstTabbable = $tabbables.first();
        const $lastTabbable = $tabbables.last();

        if (!event.shiftKey && ($lastTabbable.is(this) || $.contains($lastTabbable, this))) {
          event.preventDefault();
          $firstTabbable.focus();
        } else if (event.shiftKey && ($firstTabbable.is(this) || $.contains($firstTabbable, this))) {
          event.preventDefault();
          $lastTabbable.focus();
        }
      }
    });
  }

  unlockFocus () {
    $(this.dialog).off('keydown.lock-focus');
  }

  onConnected () {}
  onShown () {}
  onClosed () {}
  onDisconnected () {}

}

function onCancel (event) {
  if (event.target === this.dialog) {
    if (this.dispatchCancel()) {
      this.returnValue = undefined;
    } else {
      event.preventDefault();
    }
  }
}

function onClose (event) {
  if (event.target === this.dialog) {
    this.unlockFocus();

    if (this.activeElement) {
      this.activeElement.focus();
      this.activeElement = null;
    }

    this.onClosed();
    this.dispatchClose();
  }
}

function onClick (event) {
  const target = event.target;
  const dialog = this.dialog;
  if ((target === dialog && !eventIsInRect(event, dialog.getBoundingClientRect())) || target.closest('.cancel')) {
    this.cancel();
  }
}

function eventIsInRect (event, rect) {
  return (rect.top <= event.clientY && rect.top + rect.height >= event.clientY &&
    rect.left <= event.clientX && rect.left + rect.width >= event.clientX);
}
